import { useState, useEffect } from "react";
import { Form, Card, Row, Col, Button, Spinner } from "react-bootstrap";
import { FiArrowLeft, FiDownload, FiUpload } from "react-icons/fi";
import bsCustomFileInput from "bs-custom-file-input";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from "sweetalert2";

import { onSubmitHabilitacion } from "../utils/onSubmit";
import { validation } from "../utils/validation";
import { handleDocExtensions, handleFileExtensions, handleFileSize, handleImageExtensions } from "../utils/filesHandlers";
import { dowloadFile } from "../services/transport.services";
// import { ModalPayment } from "./ModalPayment";

const HabilitacionForm = () => {
  const [docName, setDocName] = useState({
    legalPerson: [],
  });
  const [loading, setLoading] = useState();
  const [downloadLoading, setdownloadLoading] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validation),
  });

  const [data, setData] = useState();

  useEffect(() => {
    bsCustomFileInput.init();

    if (localStorage.getItem('data')) {
      let dataStorage = localStorage.getItem('data');
      setData(JSON.parse(dataStorage));
    }
  }, []);

  useEffect(() => {
    bsCustomFileInput.init();
  }, []);

  const onsumbit = async (data) => {
    await onSubmitHabilitacion(data, setLoading);
  };

  if (loading) {
    return (
      <div
        className='d-flex justify-content-center align-items-center flex-column mt-5'
        style={{ minHeight: '60vh' }}
      >
        <Button variant='primary' disabled>
          <Spinner
            as='span'
            animation='grow'
            size='sm'
            role='status'
            aria-hidden='true'
            className='mr-2'
          />
          Enviando...
        </Button>
      </div>
    );
  }


  const handleChange = (e) => {
    switch (e.target.id) {
      case "DNIpdf":
        if (e.target?.files[0]?.name) setDocName({ ...docName, DNIpdf: e.target?.files[0]?.name });
        else setDocName({ ...docName, DNIpdf: "" });
        break;
      case "afip":
        if (e.target?.files[0]?.name) setDocName({ ...docName, afip: e.target?.files[0]?.name });
        else setDocName({ ...docName, afip: "" });
        break;
      case "iibb":
        if (e.target?.files[0]?.name) setDocName({ ...docName, iibb: e.target?.files[0]?.name });
        else setDocName({ ...docName, iibb: "" });
        break;
      case "libre_deuda":
        if (e.target?.files[0]?.name) setDocName({ ...docName, libre_deuda: e.target?.files[0]?.name });
        else setDocName({ ...docName, libre_deuda: "" });
        break;
      case "libre_multa":
        if (e.target?.files[0]?.name) setDocName({ ...docName, libre_multa: e.target?.files[0]?.name });
        else setDocName({ ...docName, libre_multa: "" });
        break;
      case "antecedentes":
        if (e.target?.files[0]?.name) setDocName({ ...docName, antecedentes: e.target?.files[0]?.name });
        else setDocName({ ...docName, antecedentes: "" });
        break;
      case "carnet":
        if (e.target?.files[0]?.name) setDocName({ ...docName, carnet: e.target?.files[0]?.name });
        else setDocName({ ...docName, carnet: "" });
        break;
      case "legalPerson":
        let files = Object.values(e.target.files);
        if (files.length) setDocName({ ...docName, legalPerson: files.map(file => file?.name) })
        else setDocName({ ...docName, legalPerson: "" });
        break;
      case "titulo":
        if (e.target?.files[0]?.name) setDocName({ ...docName, titulo: e.target?.files[0]?.name });
        else setDocName({ ...docName, titulo: "" });
        break;
      case "vtv":
        if (e.target?.files[0]?.name) setDocName({ ...docName, vtv: e.target?.files[0]?.name });
        else setDocName({ ...docName, vtv: "" });
        break;
      case "cedula":
        if (e.target?.files[0]?.name) setDocName({ ...docName, cedula: e.target?.files[0]?.name });
        else setDocName({ ...docName, cedula: "" });
        break;
      case "seguro_responsabilidad_civil":
        if (e.target?.files[0]?.name) setDocName({ ...docName, seguro_responsabilidad_civil: e.target?.files[0]?.name });
        else setDocName({ ...docName, seguro_responsabilidad_civil: "" });
        break;
      case "poliza":
        if (e.target?.files[0]?.name) setDocName({ ...docName, poliza: e.target?.files[0]?.name });
        else setDocName({ ...docName, poliza: "" });
        break;
      case "pago_seguro":
        if (e.target?.files[0]?.name) setDocName({ ...docName, pago_seguro: e.target?.files[0]?.name });
        else setDocName({ ...docName, pago_seguro: "" });
        break;
      case "carnet_chofer":
        if (e.target?.files[0]?.name) setDocName({ ...docName, carnet_chofer: e.target?.files[0]?.name });
        else setDocName({ ...docName, carnet_chofer: "" });
        break;
      case "dni_celador":
        if (e.target?.files[0]?.name) setDocName({ ...docName, dni_celador: e.target?.files[0]?.name });
        else setDocName({ ...docName, dni_celador: "" });
        break;
      case "antecedentes_celador":
        if (e.target?.files[0]?.name) setDocName({ ...docName, antecedentes_celador: e.target?.files[0]?.name });
        else setDocName({ ...docName, antecedentes_celador: "" });
        break;
      case "imgFront":
        if (e.target?.files[0]?.name) setDocName({ ...docName, imgFront: e.target?.files[0]?.name });
        else setDocName({ ...docName, imgFront: "" });
        break;
      case "imgSide":
        if (e.target?.files[0]?.name) setDocName({ ...docName, imgSide: e.target?.files[0]?.name });
        else setDocName({ ...docName, imgSide: "" });
        break;
      case "imgBack":
        if (e.target?.files[0]?.name) setDocName({ ...docName, imgBack: e.target?.files[0]?.name });
        else setDocName({ ...docName, imgBack: "" });
        break;
      case "imgIn":
        if (e.target?.files[0]?.name) setDocName({ ...docName, imgIn: e.target?.files[0]?.name });
        else setDocName({ ...docName, imgIn: "" });
        break;
      case "declaracion_jurada":
        if (e.target?.files[0]?.name) setDocName({ ...docName, declaracion_jurada: e.target?.files[0]?.name });
        else setDocName({ ...docName, declaracion_jurada: "" });
        break;
      // case "office":
      //   if (e.target?.files[0]?.name) setDocName({ ...docName, office: e.target?.files[0]?.name });
      //   else setDocName({ ...docName, office: "" });
      //   break;
      default:
        return;
    }
  };

  async function download() {
    setdownloadLoading(true)
    let response = await dowloadFile();

    if (response.status === 200) {
      var byteArray = new Uint8Array(response?.data?.file?.data);
      var a = window.document.createElement('a');

      a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' }));
      a.download = "ddjj-escolar.pdf";

      document.body.appendChild(a)
      a.click();

      document.body.removeChild(a)
    }
    else {
      Swal.fire(
        "Error",
        "No se pudo descargar el archivo, por favor haga click en el enlace de arriba y descarguelo manualmente.",
        "error",
      );
    }
    setdownloadLoading(false)
  }

  return (
    <>
      <div className="return-button">
        <Link style={{ textDecoration: "none" }} to="/transporte">
          <Button className="d-flex aling-items-center text-uppercase" variant="outline-primary">
            <FiArrowLeft size="1.5rem" />
            <span className="mx-1">Volver</span>
          </Button>
        </Link>
      </div>
      <Form
        className="container mt-5 mb-5 form text-uppercase"
        onSubmit={handleSubmit(onsumbit)}
      >
        <Card className="shadow mb-5 bg-white rounded form__card">
          <Card.Header className="form__card--header">
            Datos del titular del vehículo
          </Card.Header>
          <Card.Body>
            <Form.Group>
              <Row className="mb-2">
                <Col sm={12} md={6} className="mb-2">
                  <Form.Label>Apellido</Form.Label>
                  <Form.Control name="lastname" {...register("lastname")} isInvalid={!!errors.lastname} />
                  <Form.Control.Feedback type="invalid">{errors.lastname?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6} className="mb-2">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control name="firstname"  {...register("firstname")} isInvalid={!!errors.firstname} />
                  <Form.Control.Feedback type="invalid">{errors.firstname?.message}</Form.Control.Feedback>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col className="mb-2" sm={12} md={3}>
                  <Form.Label>DNI</Form.Label>
                  <Form.Control name="dni" {...register("dni")} isInvalid={!!errors.dni} />
                  <Form.Control.Feedback type="invalid">{errors.dni?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={6} md={3} className="mb-4">
                  <Form.Label>Copia DNI (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="dni">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="DNIpdf"
                        id="DNIpdf"
                        accept="application/pdf"
                        {...register('DNIpdf', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.DNIpdf}</span>
                </Col>
                <Col className="mb-2" sm={12} md={3}>
                  <Form.Label>CUIT</Form.Label>
                  <Form.Control name="cuit" {...register("cuit")} isInvalid={!!errors.cuit} />
                  <Form.Control.Feedback type="invalid">{errors.cuit?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={3} className="mb-4">
                  <Form.Label>Inscripción AFIP (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="afip">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="afip"
                        id="afip"
                        accept="application/pdf"
                        {...register('afip', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.afip}</span>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col sm={6} md={3} className="mb-4">
                  <Form.Label>
                    Inscripción en ingresos brutos (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="iibb">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="iibb"
                        id="iibb"
                        accept="application/pdf"
                        {...register('iibb', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.iibb}</span>
                </Col>
                <Col sm={6} md={3} className="mb-4">
                  <Form.Label>
                    Constancia libre deuda de comercio (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="libre-deuda">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="libre_deuda"
                        id="libre_deuda"
                        accept="application/pdf"
                        {...register('libre_deuda', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.libre_deuda}</span>
                </Col>
                <Col sm={12} md={6} className="mb-4">
                  <Form.Label>
                    Constancia libre multa del juzgado de faltas (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="libre-multa">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="libre_multa"
                        id="libre_multa"
                        accept="application/pdf"
                        {...register('libre_multa', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.libre_multa}</span>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label>Domicilio real</Form.Label>
                  <Form.Control name="address" {...register("address")} isInvalid={!!errors.address} />
                  <Form.Control.Feedback type="invalid">{errors.address?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={6} className="mb-sm-3 mt-3">
                  <Form.Label>Correo electrónico</Form.Label>
                  <Form.Control name="email" {...register("email")} type="email" isInvalid={!!errors.email} />
                  <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col sm={12} md={6}>
                  <Form.Label>
                    Certificado de antecedentes (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="antecedentes">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="antecedentes"
                        id="antecedentes"
                        accept="application/pdf"
                        {...register('antecedentes', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.antecedentes}</span>
                </Col>
                <Col sm={12} md={6} className="mb-4">
                  <Form.Label>Carnet de conductor (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="carnet">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="carnet"
                        id="carnet"
                        accept="application/pdf"
                        {...register('carnet', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.carnet}</span>
                </Col>
              </Row>
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="shadow mb-5 bg-white rounded form__card">
          <Card.Header className="form__card--header">
            Datos de persona jurídica (De corresponder)
          </Card.Header>
          <Card.Body>
            <Form.Label>
              Documentación que respalde la personeria invocada (poder, estatutos,
              contrato social, etc)
            </Form.Label>
            <div className="form-file">
              <FiUpload className="upload-link" />
              <div className="file-select">
                <label htmlFor="legalPerson">Cargar</label>
                <Form.Control
                  type="file"
                  onInput={(e) => {
                    handleFileExtensions(e);
                    handleFileSize(e);
                  }}
                  name="legalPerson"
                  id="legalPerson"
                  accept="application/pdf,.jpg,.png"
                  multiple
                  {...register('legalPerson', {
                    onChange: handleChange
                  })}
                />
              </div>
            </div>
            <ul className="p-0">
              {docName.legalPerson.length ? docName.legalPerson.map((name, i) => <li key={name + i} className="doc-name">{name}</li>) : null}
            </ul>
          </Card.Body>
        </Card>

        <Card className="shadow mb-5 bg-white rounded form__card">
          <Card.Header className="form__card--header">
            Datos del vehículo
          </Card.Header>
          <Card.Body>
            <Form.Group>
              <Row className="mb-4">
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>Dominio</Form.Label>
                  <Form.Control
                    name="domain"
                    id="domain"
                    isInvalid={!!errors?.domain}
                    {...register("domain")}
                  />
                  <Form.Control.Feedback type="invalid">{errors.domain?.message}</Form.Control.Feedback>
                </Col>
                <Col sm={12} md={3} className="mb-4">
                  <Form.Label>Copia del título (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="titulo">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="titulo"
                        id="titulo"
                        accept="application/pdf"
                        {...register('titulo', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.titulo}</span>
                </Col>
                <Col sm={12} md={3} className="mb-4">
                  <Form.Label>Copia VTV vigente (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="vtv">Cargar</label>
                      <Form.Control
                        type="file"
                        name="vtv"
                        id="vtv"
                        accept="application/pdf"
                        {...register('vtv', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.vtv}</span>
                </Col>
                <Col sm={12} md={3} className="mb-4">
                  <Form.Label>Copia cédula verde (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="vtv">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="cedula"
                        id="cedula"
                        accept="application/pdf"
                        {...register('cedula', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.cedula}</span>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col sm={12} md={6} className="mb-2">
                  <Form.Label>
                    Seguro de responsabilidad civil de transporte escolar con
                    capacidad de pasajeros transportados
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="seguro-responsabilidad-civil">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="seguro_responsabilidad_civil"
                        id="seguro_responsabilidad_civil"
                        accept="application/pdf"
                        {...register('seguro_responsabilidad_civil', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.seguro_responsabilidad_civil}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>
                    Copia de la poliza vigente (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="poliza">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="poliza"
                        id="poliza"
                        accept="application/pdf"
                        {...register('poliza', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.poliza}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>
                    Comprobante de pago seguro (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="pago-seguro">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="pago_seguro"
                        id="pago_seguro"
                        accept="application/pdf"
                        {...register('pago_seguro', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.pago_seguro}</span>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col className="mt-3">
                  <Form.Label>
                    Chofer
                  </Form.Label>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>Carnet del chofer (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="carnet-chofer">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="carnet_chofer"
                        id="carnet_chofer"
                        accept="application/pdf"
                        {...register('carnet_chofer', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.carnet_chofer}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>Copia DNI del celador (Formato PDF)</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="dni_celador">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="dni_celador"
                        id="dni_celador"
                        accept="application/pdf"
                        {...register('dni_celador', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.dni_celador}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>
                    Certificado de antecedentes del celador (Formato PDF)
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="antecedentes-celador">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleDocExtensions(e);
                          handleFileSize(e);
                        }}
                        name="antecedentes_celador"
                        id="antecedentes_celador"
                        accept="application/pdf"
                        {...register('antecedentes_celador', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.antecedentes_celador}</span>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col className="mt-3">
                  <Form.Label>
                    Fotografias del vehículo (Formato JPG o PNG)
                  </Form.Label>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>Frente</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="imgFront">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleImageExtensions(e);
                          handleFileSize(e);
                        }}
                        name="imgFront"
                        id="imgFront"
                        accept=".jpg,.png"
                        {...register('imgFront', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.imgFront}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>Perfil</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="imgSide">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleImageExtensions(e);
                          handleFileSize(e);
                        }}
                        name="imgSide"
                        id="imgSide"
                        accept=".jpg,.png"
                        {...register('imgSide', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.imgSide}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>Parte trasera</Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="imgBack">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleImageExtensions(e);
                          handleFileSize(e);
                        }}
                        name="imgBack"
                        id="imgBack"
                        accept=".jpg,.png"
                        {...register('imgBack', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.imgBack}</span>
                </Col>
                <Col sm={12} md={3} className="mb-2">
                  <Form.Label>
                    Parte de adentro con vistas a los asientos con cinturones y
                    apollacabezas
                  </Form.Label>
                  <div className="form-file">
                    <FiUpload className="upload-link" />
                    <div className="file-select">
                      <label htmlFor="imgIn">Cargar</label>
                      <Form.Control
                        type="file"
                        onInput={(e) => {
                          handleImageExtensions(e);
                          handleFileSize(e);
                        }}
                        name="imgIn"
                        id="imgIn"
                        accept=".jpg,.png"
                        {...register('imgIn', {
                          onChange: handleChange
                        })}
                      />
                    </div>
                  </div>
                  <span className="doc-name">{docName.imgIn}</span>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col className="mt-2">
                  <Form.Label>Categoría del vehículo</Form.Label>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col>
                  <Form.Control className="text-uppercase" as="select" name="category"  {...register("category")}>
                    <option>
                      Transporte escolar convencional.
                    </option>
                  </Form.Control>
                </Col>
              </Row>
            </Form.Group>
          </Card.Body>
        </Card>

        <Card className="shadow mb-5 bg-white rounded form__card">
          <Card.Header className="form__card--header">Documentación</Card.Header>
          <Card.Body>
            <Form.Group>
              <Row className="mb-2">
                <Col>
                  <Form.Label className="mb-2">
                    Completá la siguiente declaración jurada{" "}
                    <a href="https://staticcontent.sannicolasciudad.gob.ar/images/transpescolar/ddjj/ddjj-escolar.pdf" className="primary" target="_blank" rel="noreferrer">
                      aquí
                    </a>
                  </Form.Label>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col sm={12} md={6} className="mb-2">
                  <Form.Label>Adjuntá la declaración jurada firmada</Form.Label>
                  <div className='d-flex'>
                    <div
                      className={`form-file file-download mb-4 ${downloadLoading ? "div_downloading" : "div_download"} `}
                      onClick={() => download()}
                    >
                      <FiDownload className='download-link' />
                    </div>
                    <div className="form-file">
                      <FiUpload className="upload-link" />
                      <div className="file-select">
                        <label htmlFor="declaracion-jurada">Cargar</label>
                        <Form.Control
                          type="file"
                          onInput={(e) => {
                            handleFileExtensions(e);
                            handleFileSize(e);
                          }}
                          name="declaracion_jurada"
                          id="declaracion_jurada"
                          accept="application/pdf,.jpg,.png"
                          {...register('declaracion_jurada', {
                            onChange: handleChange
                          })}
                        />
                      </div>
                    </div>
                  </div>
                  <span className="doc-name">{docName.declaracion_jurada}</span>
                </Col>
              </Row>
            </Form.Group>
          </Card.Body>
        </Card>
        {/* <Card className="shadow mb-5 bg-white rounded form__card">
          <Card.Header className="form__card--header">DERECHO DE OFICINA</Card.Header>
          <Card.Body>
            <Form.Group>
              <Row className="mb-2">
                <Col>
                  <Form.Label className='mb-2'>
                    Generá tu derecho por habilitación de autorización o permiso{' '}
                    <button 
                      className="custom-link"
                      type="button"
                      onClick={() => ModalPayment(data?.codigo)}
                    >
                      AQUÍ
                    </button>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    onInput={(e) => {
                      handleFileExtensions(e);
                      handleFileSize(e);
                    }}
                    name='office'
                    label='Adjuntá aquí el comprobante de pago'
                    custom
                    accept='application/pdf,.jpg,.png'
                    data-browse='Adjuntar'
                    {...register('office')}
                  />
                </Col>
              </Row>
            </Form.Group>
          </Card.Body>
        </Card> */}
        <Button type="submit" variant="outline-primary" className="p-2 pl-4 pr-4 text-uppercase">
          Enviar solicitud
        </Button>
      </Form>
    </>
  );
};

export default HabilitacionForm;
